/*=========================================================================================
  File Name: moduleSigep.js
  Description: Sigep Module
==========================================================================================*/


import state from './moduleSigepState.js'
import mutations from './moduleSigepMutations.js'
import actions from './moduleSigepActions.js'
import getters from './moduleSigepGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
